import { createMuiTheme } from 'material-ui/styles';
import { green, orange, grey, FRNDarkBlueGray } from './colors';

const fontWeightLight = 300;
const fontWeightMedium = 500;
const fontWeightHeavy = 900;
const letterSpacing = '.4px';

const theme = createMuiTheme({
  typography: {
    fontFamily:
      'proxima-nova, "Helvetica Neue", Arial, sans-serif',
    color: FRNDarkBlueGray,
    display2: {
      color: FRNDarkBlueGray
    },
    body1: {
      letterSpacing,
      fontSize: '1.2em',
      color: FRNDarkBlueGray
    },
    headline: {
      fontWeight: fontWeightLight
    },
    body2: {
      color: green[500],
      padding: '0',
      textDecoration: 'underline'
    }
  },
  a: {
    color: green
  },
  textField: {
    marginBottom: '.5em',
    width: '100%'
  },
  Input: {
    fontSize: '1.2rem',
    letterSpacing,
    marginRight: '4px',
    padding: '0 8px 0 4px'
  },
  input: {
    letterSpacing
  },
  button: {
    borderRadius: '8px',
    color: 'white',
    fontSize: '1.2em',
    fontWeight: '200',
    minHeight: '65px',
    textTransform: 'none'
  },
  palette: {
    primary: green,
    secondary: orange,
    error: orange,
    contrast: grey
  }
});

export default theme;



// WEBPACK FOOTER //
// ./theme/index.js